// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3bDG1","selected":"Chip_selected__21RWI"};